module.exports = __webpack_public_path__ + "assets/img/1e60715fcb76c4fa46a9cf12a9716ead.png";